import template from "./user-form.html";
import "./user-form.less";
import {
	trim,
	keyBy
} from "lodash";
import { NAME_SUFFIX_LIST } from "../../../constants";
import {
	FORM_USERS,
	FORM_USER_ROLES
} from "../../../routes";

//user-form
export function controller(
	api,
	toastr,
	loadingService,
	config,
	appState
) {
	const ctrl = this;

	ctrl.readonly = appState.permissions.Administration.IsDisabled || appState.permissions.Administration.User.IsDisabled || !appState.permissions.Administration.User.Actions.CanEdit;

	ctrl.saveUser = saveUser;
	ctrl.$onInit = onInit;
	ctrl.invalidSuffix = null;
	ctrl.securityRoles = [];
	ctrl.userRole = null;

	function onInit() {
		ctrl.suffixOptions = [{
			key: "",
			display: ""
		}].concat(NAME_SUFFIX_LIST.filter((s) => s.show === true));
		ctrl.suffixMap = keyBy(NAME_SUFFIX_LIST, (s) => s.key);
		ctrl.securityRoles = appState.forms.selected.Security?.Roles || [];

		if(ctrl.user && ctrl.user.Contact && ctrl.user.Contact.Suffix) {
			if(!ctrl.suffixMap[ctrl.user.Contact.Suffix]) {
				ctrl.invalidSuffix = ctrl.user.Contact.Suffix;
				// ctrl.user.Contact.Suffix = "";
			} else {
				ctrl.user.Contact.Suffix = ctrl.suffixMap[ctrl.user.Contact.Suffix].display;
			}
		} else {
			ctrl.user = ctrl.user || {};
			ctrl.user.Contact = ctrl.user.Contact || {};
			ctrl.user.Contact.Suffix = ctrl.user.Contact.Suffix || "";
		}

		loadUserDetails();
	}

	function findSecurityRole(code) {
		return ctrl.securityRoles.find((role) => role.Code === code)
			|| appState.forms.selected.Security?.Roles?.find((role) => role.Code === code)
			|| null;
	}

	function saveUser() {
		const params = {
			Id: ctrl.user.Id,
			ClientId: config.clientId,
			UserName: trim(ctrl.user.UserName || ctrl.user.Username),
			Contact: {
				FirstName: trim(ctrl.user.Contact.FirstName),
				MiddleName: trim(ctrl.user.Contact.MiddleName),
				LastName: trim(ctrl.user.Contact.LastName),
				Suffix: trim(ctrl.user.Contact.Suffix)
			}
		};

		if(ctrl.user.Id) {
			updateUser(params);
			return;
		}

		createUser(params);
	}

	function loadUserDetails() {
		if(ctrl.user.Id !== undefined) {
			const promise = api.get(FORM_USER_ROLES(appState.forms.selected.Id, ctrl.user.Id))
				.then(response => {
					const currentRole = response[0];

					ctrl.userRole = findSecurityRole(currentRole?.Code);
				});

			loadingService.watch(promise);
		}
	}

	function createUser(user) {
		let apiRole = null;

		if(ctrl.userRole?.Code !== undefined && ctrl.userRole?.Code.trim() !== "") {
			apiRole = findSecurityRole(ctrl.userRole.Code);
		}

		if(!apiRole) {
			return;
		}

		user.Role = { Code: apiRole.Code, Name: "" };

		const promise = api.post(FORM_USERS(appState.forms.selected.Id), user)
			.then(response => {
				toastr.success(
					"The user's account has been associated to your form. If the user is new to VESL a notification is on it's way.",
					"User Account Associated"
				);

				ctrl.setUser({
					user: response
				});
			});

		loadingService.watch(promise, "Loading...");
	}

	function updateUser(user) {
		const userUpdate = api.put("api/users", user);
		const apiRole = ctrl.userRole?.Code
			? appState.forms.selected.Security?.Roles?.find(r => r.Code === ctrl.userRole.Code)
			: null;
		const updates = [userUpdate];

		if(apiRole) {
			updates.push(api.put(FORM_USER_ROLES(appState.forms.selected.Id, ctrl.user.Id), [{ Code: apiRole.Code, Name: "" }]));
		}

		const fullUpdate = Promise.all(updates).then(() => 
			toastr.success(apiRole
				? "User updated successfully.  Note that any user role updates may take 10 minutes to update."
				: "User updated successfully.")
		);

		loadingService.watch(fullUpdate, "Loading...");
	}
}

export default angular
	.module("vesl.components.user-form", ["ngMessages"])
	.component("userForm", {
		controller,
		template,
		bindings: {
			user: "<",
			reload: "&",
			setUser: "&",
			permissions: "<"
		}
	}).name;
